/**
 * DẤU «ẢNH BÌA VỪA THAY» (17/10/2026): video nào vừa gửi ảnh bìa mới thì nhớ giờ thay (localStorage, 24 giờ) để bảng
 * Video vẽ ảnh với địa chỉ có `v=` — xem `freshThumbnailUrl`. Giữ ngoài component để chuyển tab hay F5 vẫn còn.
 */
import { create } from 'zustand';
import { pruneThumbnailMarks } from '@/domain/video-publish';

const KEY = 'halo-thumb-changed';

function load(): Record<string, number> {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : null;
    if (!parsed || typeof parsed !== 'object') return {};
    const marks: Record<string, number> = {};
    for (const [id, at] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof at === 'number' && Number.isFinite(at)) marks[id] = at;
    }
    return pruneThumbnailMarks(marks, Date.now());
  } catch {
    return {};
  }
}

function save(marks: Record<string, number>): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(marks));
  } catch {
    // không lưu được thì dấu chỉ còn trong phiên này
  }
}

interface ThumbnailMarksState {
  /** Mã video → lúc thay ảnh (ms). */
  marks: Record<string, number>;
  mark: (videoId: string, at?: number) => void;
  /** Lần bấm «Tải lại» gần nhất (ms, chỉ trong phiên): mọi ảnh bìa xin lại. */
  reloadedAt: number;
  bumpAll: (at?: number) => void;
}

export const useThumbnailMarks = create<ThumbnailMarksState>((set, get) => ({
  marks: load(),
  mark(videoId, at = Date.now()) {
    const marks = pruneThumbnailMarks({ ...get().marks, [videoId]: at }, at);
    set({ marks });
    save(marks);
  },
  reloadedAt: 0,
  bumpAll(at = Date.now()) {
    set({ reloadedAt: at });
  },
}));
